import React from 'react';

import * as stylesHeader from './Header.module.less';
import FleetbackIcon from '../../base/icons/fleetback-icon.svg';
import FleetbackLabel from '../../base/icons/fleetback-label.svg';

const FleetbackLogos = () => (
  <>
    <FleetbackIcon className={stylesHeader['header-logo__ico']} width="39" height="33" />
    <FleetbackLabel className={stylesHeader['header-logo__label']} width="85" />
  </>
);

export default FleetbackLogos;
